import { Checkbox, FormControlLabel } from '@mui/material';
import {
    CheckboxChecked,
    CheckboxUnchecked,
} from '@resurs-internal/mui/components/SelectCheckboxField/SelectCheckboxField';
import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { ChangeEvent, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { addOrUpdateFormField } from '../../store/applicationform';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';
import { IFieldState } from '../../store/applicationform/applicationFormTypes';
import { CheckboxFieldStyles } from '../CheckboxField/Checkbox.styles';
import ValidationError from '../ValidationError/ValidationError';

export type MultipleCheckboxFieldProps = {
    name: string;
    options: SelectFieldOption[];
};

const MultipleCheckboxField = (props: MultipleCheckboxFieldProps) => {
    const dispatch = useAppDispatch();
    const field = useAppSelector(selectFieldStateByName)(props.name);
    const [selectedValues, setSelectedValues] = useState<string[]>((field?.value as string[]) ?? []);

    const handleChange = (event: ChangeEvent<HTMLInputElement>, optionLabel: string) => {
        const isChecked = event.target.checked;

        let updatedValues;

        if (isChecked) {
            updatedValues = [...selectedValues, optionLabel];
        } else {
            updatedValues = selectedValues.filter((value) => value !== optionLabel);
        }

        setSelectedValues(updatedValues);
        dispatch(
            addOrUpdateFormField({
                fieldName: props.name,
                value: updatedValues,
                hasError: false,
            } as IFieldState),
        );
    };

    return (
        <>
            {props.options.map((option) => (
                <CheckboxFieldStyles key={option.id}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                onChange={(event) => handleChange(event, option.label as string)}
                                value={option.label}
                                checked={selectedValues.includes(option.label as string)}
                                icon={<CheckboxUnchecked />}
                                checkedIcon={<CheckboxChecked />}
                            />
                        }
                        label={option.label}
                    />
                </CheckboxFieldStyles>
            ))}
            <ValidationError fieldName={props.name} />
        </>
    );
};

export default MultipleCheckboxField;
